import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./CommonModal.scss";
import { unlockBodyScroll } from "../../utility/utils";

type ModalSize = "sm" | "lg" | "xl" | "md" | undefined;

type CommonModalProps = {
  show: boolean;
  onHide: () => void;
  title?: string;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
  header?: React.ReactNode;
  showHeader?: boolean;
  footer?: React.ReactNode;
  showFooter?: boolean;
  submitText?: string;
  centered?: any;
  contentClassName: string;
};

const CommonModal: React.FC<CommonModalProps> = ({
  show,
  onHide,
  title,
  children,
  size = "md",
  header,
  showHeader = true,
  footer,
  showFooter = false,
  submitText = "Submit",
  centered = true,
  contentClassName
}) => {
  const getSize = () => (size === "md" ? undefined : size);

  return (
    <Modal
      show={show}
      onHide={onHide}
      onExited={() => {
        // Defer so Bootstrap finishes removing its own portal nodes first
        window.setTimeout(unlockBodyScroll, 0);
      }}
      size={getSize()}
      centered={centered}
      contentClassName={contentClassName}
      restoreFocus={false}
      enforceFocus={false}
    >
      {showHeader && (header ? (
        header
      ) : (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      ))}

      <Modal.Body>{children}</Modal.Body>

      {showFooter && (
        <Modal.Footer>
          {footer ? (
            footer
          ) : (
            <>
              {/* <Button variant="secondary" onClick={onHide}>
                Close
              </Button> */}
              <Button variant="primary" onClick={onHide}>
                {submitText}
              </Button>
            </>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CommonModal;
